import { useEffect, useRef, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../../components/Grid/Grid";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
import PageTitle from "../../components/PageTitle/PageTitle";
import { permissionsInterface } from "../onBoarding/onBoardingTypes";
import { useSelector } from "react-redux";
import moment from "moment";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { PiExport } from "react-icons/pi";

const headers: GridHeader[] = [
    {
        title: "Booking ID",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "b.book_id",
    },
    {
        title: "Booking Date",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "b.created_at",
    },
    {
        title: "Project name",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "p.project_name",
    },
    {
        title: "Customer Name/Mobile",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "b.customer_name",
    },
    {
        title: "Unit Names",
        class: "text-left",
        isSorting: false,
    },
    {
        title: "Agent Name/Mobile",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "b.agent_name",
    },
    {
        title: "Amount Due till date",
        class: "text-left",
        isSorting: true,
        isAsc: true,
        sortingKey: "b.total_cost",
    },
    {
        title: "Amount Received",
        class: "text-left",
    },
    {
        title: "Amount Remaining till date",
        class: "text-left",
    },
    {
        title: "Due Date",
        class: "text-left",
    }
];


const DueReport = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<GridRow[]>([]);
    const nextOffset = useRef<number>(0);
    const [pressedKeys, setPressedKeys] = useState(new Set());
    const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
    const token = useSelector((state: any) => state.OnBoardingReducer);
    const [permissions, setPermissions] = useState<permissionsInterface | null>(null);
    const [projectOptions, setProjectOptions] = useState<any[]>([]);
    const [totalAmountTillDate, setTotalAmountTillDate] = useState<number>(0);
    const [totalRecivedAmountTillDate, setTotalRecivedAmountTillDate] = useState<number>(0);
    const [totalDueAmountTillDate, setTotalDueAmountTillDate] = useState<number>(0);
    const [totalCount, setTotalCount] = useState<number>(0);
    const searchParams = new URLSearchParams(window.location.search);
    const fromDate = searchParams.get("fromDate") ? new Date(searchParams.get("fromDate") as string) : null;
    const toDate = searchParams.get("toDate") ? new Date(searchParams.get("toDate") as string) : null;
    const [startDate, setStartDate] = useState<Date | any>("");
    const [endDate, setEndDate] = useState<Date | any>("");
    const [keyword, setKeyword] = useState<string>("");
    const [projectId, setProjectId] = useState<string>("");

    useEffect(() => {
        if (token && token.token && token.permissions && !!token.permissions.length) {
            setPermissions(token.permissions.find((item: any) => item.name === "PAYMENT_DUE_REPORT"));
            !projectOptions.length && getProjectList()
        }
    }, [token])


    useEffect(() => {
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        };
    }, [pressedKeys]);

    useEffect(() => {
        if (showHiddenFields) {
            getDueList(1);
        }
    }, [showHiddenFields]);

    const getDueList = (
        offset: number,
        keyword?: string,
        startDate?: Date,
        endDate?: Date,
        project_id?: number,
        order_by?: string,
        sort_by?: string
    ) => {

        nextOffset.current = offset;
        if (nextOffset.current < 0 || isLoading) {
            return;
        }
        setIsLoading(true);
        WebService.getAPI({
            action: `due-report/pagination/list?limit=10&offset=${offset - 1}&keyword=${keyword ? keyword : ""}&project_id=${project_id ? project_id : ""}&sort_by=${order_by ?? "asc"}&order_by=${sort_by ?? "b.created_at"}&from_date=${startDate ? startDate : fromDate ?? ""}&to_date=${endDate ? endDate : toDate ?? ""}`,
            body: null,
            is_session: showHiddenFields
        })
            .then((res: any) => {
                setIsLoading(false);
                setRows(res.list);
                if (offset == 1) {
                    setTotalAmountTillDate(res.totalAmountTillDate);
                    setTotalRecivedAmountTillDate(res.totalRecivedAmountTillDate);
                    setTotalDueAmountTillDate(res.totalDueAmountTillDate);
                }
                setTotalCount(res.count);
                setStartDate(startDate ?? "");
                setEndDate(endDate ?? "");
                setKeyword(keyword ?? "");
                setProjectId(project_id ?? "" as any);
            })
            .catch((e) => {
                setIsLoading(false);
            });
    };

    const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
        getDueList(
            offset,
            null as any,
            null as any,
            null as any,
            null as any,
            isAscending ? "asc" : "desc",
            key
        );
    };

    const getFormatedRows = (data: any[]) => {
        let rows: GridRow[] = [];
        for (var i in data) {
            try {
                let columns: GridColumn[] = [];
                columns.push({ value: data[i].book_id ? data[i].book_id : "N/A" });
                columns.push({ value: data[i].booking_date ? HelperService.getFormatedDate(data[i].booking_date) : "N/A" });
                columns.push({ value: data[i].project_name ? data[i].project_name : "N/A" });
                columns.push({ value: data[i].customer_name ? `${data[i].customer_name} (${HelperService.getFormattedContact(data[i].customer_phone)})` : "N/A", });
                columns.push({ value: data[i].unit_names ? data[i].unit_names : "N/A" });
                columns.push({ value: data[i].agent_name ? `${data[i].agent_name} (${HelperService.getFormattedContact(data[i].agent_phone)})` : "N/A", });
                columns.push({ value: HelperService.getCurrencyFormatter(data[i].total_cost) });
                columns.push({ value: HelperService.getCurrencyFormatter(data[i].total_paid_amount) });
                columns.push({ value: HelperService.getCurrencyFormatter(data[i].total_due_amount) });
                columns.push({ value: HelperService.getFormatedDate(data[i].payment_date) });
                // if payment_date < today
                rows.push({ data: columns, isRed: moment(data[i].payment_date).isBefore(moment(), 'day') ? true : false });
            } catch (e) {
                console.error("Error processing row data:", e);
            }

        }
        return rows;
    };

    const handleKeyDown = (e: any) => {
        const key = e.key.toLowerCase();
        setPressedKeys((prev: any) => new Set([...prev, key]));
    };

    const handleKeyUp = (e: any) => {
        const key = e.key.toLowerCase();
        if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) {
            setShowHiddenFields(true);
        }
        setPressedKeys((prev: any) => {
            const updated = new Set(prev);
            updated.delete(key);
            return updated;
        });
    };

    const getProjectList = () => {
        WebService.getAPI({
            action: "get/project/list",
        }).then((res: any) => {
            var projectList = res.list.map((item: any) => {
                return { ...item, value: item.id, label: item.project_name };
            });
            setProjectOptions(projectList);
        });
    };

    const exportDueReport = () => {
        WebService.getAPI({
            action: `due-report/export?keyword=${keyword ? keyword : ""}&fromDate=${startDate ? startDate : ""}&toDate=${endDate ? endDate : ""}&project_id=${projectId ? projectId : ""}`,
            body: null,
            responseType: 'arraybuffer',
            is_session: showHiddenFields
        }).then((response: any) => {
            const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `due_report_${new Date().toISOString()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }).catch((e) => {
            toast.error("Failed to export due report");
        });
    };

    return (
        <>
            {permissions && permissions.can_read && <div className="app-page page-dashboard">
                <div className="d-flex justify-content-between align-items-center ">
                    <PageTitle title="Due Reports" backArrow={false} active={showHiddenFields} />
                    {permissions && permissions.can_write && permissions.can_update && <Button
                        className="btn btn-brand-1 mb-3 ms-2"
                        onClick={() => { exportDueReport(); }}
                    >
                        <PiExport size={20} className="ms-1" /> Export
                    </Button>}
                </div>

                <div className="table-card">
                    <div className="d-flex align-items-center mb-3 justify-content-between">
                        <div></div>
                        <div className="d-flex gap-3">
                            <div className="d-flex align-items-center">
                                <div style={{ backgroundColor: "white", height: "30px", width: "30px" }} className="border rounded-1"></div>
                                <span className="ms-2">Due</span>
                            </div>
                            <div className="d-flex align-items-center">
                                <div style={{ backgroundColor: "#FA8072", height: "30px", width: "30px" }} className="rounded-2"></div>
                                <span className="ms-2">Overdue</span>
                            </div>

                        </div>
                    </div>
                    <Grid
                        rows={getFormatedRows(rows)}
                        showSearch={true}
                        headers={headers}
                        showDateFilter={true}
                        onPageChange={getDueList}
                        errorMessage={"No Due Found"}
                        ShowLoader={isLoading}
                        onSort={onSortList}
                        isShowProjectFilter
                        projectOptions={projectOptions}
                        count={totalCount}
                    />
                    <div>
                        <div className="d-flex justify-content-end gap-5 mt-3 font-18 font-medium px-2">
                            <div className="d-flex align-items-center gap-2">
                                <span>Total Due Amount Till Date :-</span>
                                <span className="fw-500">{HelperService.getCurrencyFormatter(totalAmountTillDate)}</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <span>Total Received Amount Till Date :-</span>
                                <span className="fw-500">{HelperService.getCurrencyFormatter(totalRecivedAmountTillDate)}</span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <span>Total Remaining Amount Till Date :-</span>
                                <span className="fw-500">{HelperService.getCurrencyFormatter(totalDueAmountTillDate)}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>}
        </>
    );
};

export default DueReport;
